import React from 'react';
import styled from '@emotion/styled';
import { ImageIconUpload } from '..';

export const IconUpload = () => {
  return (
    <StyledIconUploadSpan className="icon-svg ImageIconUpload">
      <img src={ImageIconUpload} alt="" />
    </StyledIconUploadSpan>
  );
};

const StyledIconUploadSpan = styled.span`
  display: inline-block;
  vertical-align: sub;

  & img {
    vertical-align: sub;
    border-style: none;
  }
`;
